import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M12.5 7.5c0-1.312 1.594-2 2.531-1.062l4.5 4.5c.594.593.594 1.562 0 2.124l-4.5 4.5c-.937.938-2.531.282-2.531-1.062v-1.594h-3a1.5 1.5 0 0 1-1.5-1.5v-2.781a1.5 1.5 0 0 1 1.5-1.5h3zm6 4.5L14 7.5v3.125H9.5v2.781H14V16.5zM7 6h2.625c.188 0 .375.188.375.375v.75a.38.38 0 0 1-.375.375H7A1.5 1.5 0 0 0 5.5 9v6c0 .844.656 1.5 1.5 1.5h2.625c.188 0 .375.188.375.375v.75a.38.38 0 0 1-.375.375H7a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3"
    />
  </svg>
);
export default SvgLogout;
